import { z } from 'zod';
export const aiProposalStatusSchema = z.enum(['proposed', 'confirmed', 'rejected']);
export const aiProposalDecisionSchema = aiProposalStatusSchema.exclude(['proposed']);
export const aiProposalKindSchema = z.enum(['qbo_account_chart_line', 'charge_label_chart_line']);
export const aiProposalPayloadSchema = z.record(z.string(), z.unknown());
const chartLineProposalFields = {
    taxonomyId: z.number().int(),
    category: z.string(),
    subcategory: z.string(),
    confidence: z.enum(['high', 'medium', 'low']),
    reason: z.string(),
};
export const qboAccountChartLinePayloadSchema = z.object({
    qboName: z.string().min(1).max(500),
    ...chartLineProposalFields,
});
export const chargeLabelChartLinePayloadSchema = z.object({
    chargeType: z.string().min(1).max(50),
    ...chartLineProposalFields,
});
//# sourceMappingURL=aiProposals.js.map